import { render } from "./DocumentClassChangeForm.vue?vue&type=template&id=0c32cefa&ts=true"
import script from "./DocumentClassChangeForm.vue?vue&type=script&lang=ts"
export * from "./DocumentClassChangeForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__